import axios, {AxiosResponse, InternalAxiosRequestConfig} from 'axios';
import Links from 'src/constants/Links';
import store from "../redux/store";
import {startLoading, stopLoading} from "../redux/reducers/loadingReducer";
import {showNotification} from '../redux/reducers/notificationReducer';

const baseUrl = Links.BASE_URL_WITHOUT_TENANT;
let currentAccessToken: string | null = null;

const getErrorMessage = (error: any) => {
    if (!error.response) {
        return "Sunucuya bağlanılamadı. Lütfen internet bağlantınızı kontrol edin.";
    }

    const status = error.response.status;
    const data = error.response.data;

    // Backend'den özel bir mesaj gelmişse onu kullan
    if (data?.error || data?.detail || data?.message) {
        return data.error || data.detail || data.message;
    }

    // Standart HTTP hata mesajları
    switch (status) {
        case 400:
            return "Geçersiz istek. Lütfen verileri kontrol edin.";
        case 401:
            return "Oturum süresi dolmuş veya yetkisiz erişim.";
        case 403:
            return "Bu işlemi yapmak için yetkiniz bulunmuyor.";
        case 404:
            return "Aradığınız kaynak bulunamadı.";
        case 500:
            return "Sunucu hatası oluştu. Lütfen daha sonra tekrar deneyin.";
        default:
            return `Bir hata oluştu (Kod: ${status})`;
    }
};

const Api = {
    putAccessTokenInfo(accessToken: string | null) {
        currentAccessToken = accessToken;
    },

    getPromise<T = any>(endpoint: string, params?: object): Promise<T> {
        return axios.get<T>(baseUrl + endpoint, {params}).then(res => res.data);
    },

    getPromiseWithParams<T = any>(endpoint: string, params: any): Promise<T> {
        return axios.get<T>(baseUrl + endpoint, {params}).then(res => res.data);
    },

    postPromise<T = any>(endpoint: string, data: any, config?: any): Promise<T> {
        return axios.post<T>(baseUrl + endpoint, data, config).then(res => res.data);
    },

    postPromiseWithoutData<T = any>(endpoint: string): Promise<T> {
        return axios.post<T>(baseUrl + endpoint).then(res => res.data);
    },

    deletePromise<T = any>(endpoint: string, params: any): Promise<T> {
        return axios.delete<T>(baseUrl + endpoint, {params}).then(res => res.data);
    },

    putPromise<T = any>(endpoint: string, data: any): Promise<T> {
        return axios.put<T>(baseUrl + endpoint, data).then(res => res.data);
    },

    putPromiseWithoutData<T = any>(endpoint: string): Promise<T> {
        return axios.put<T>(baseUrl + endpoint).then(res => res.data);
    },

    patchPromise<T = any>(endpoint: string, data: any): Promise<T> {
        return axios.patch<T>(baseUrl + endpoint, data).then(res => res.data);
    },
};

axios.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    store.dispatch(startLoading());
    if (currentAccessToken) {
        config.headers.set('Authorization', `JWT ${currentAccessToken}`);
    }
    return config;
});

axios.interceptors.response.use(
    (response: AxiosResponse) => {
        store.dispatch(stopLoading());
        return response;
    },
    (error) => {
        store.dispatch(stopLoading());
        const message = getErrorMessage(error);
        store.dispatch(showNotification({message, severity: 'error'}));
        return Promise.reject(error?.response?.data || error);
    },
);

export default Api;
